<div class="mb-[11px] ml-[66px]">
  <div class="flex justify-center">
    <div
      class="ml-[12px] bg-[#f9dacf] px-[6px] pt-[4px] pb-[4px] rounded-[50%] flex justify-end items-center"
    >
      <img
        src="assets/icons/close.svg"
        alt="close"
        class="cursor-pointer w-[14px]"
        (click)="cancel()"
      />
    </div>
    <div class="ml-[12px] bg-[#f9dacf] p-[4px] rounded-[50%]">
      <img
        src="assets/icons/save.svg"
        alt="save"
        class="cursor-pointer w-[20px] pr-[2px]"
        (click)="save()"
      />
    </div>
  </div>
  <mat-form-field appearance="outline" class="milestone-input h-[80px]">
    <input
      matInput
      [matDatepicker]="picker"
      id="name"
      [formControl]="dateControl"
    />
    <mat-datepicker-toggle
    matIconSuffix
    [for]="picker"
  ></mat-datepicker-toggle>
  <mat-datepicker #picker startView="year"></mat-datepicker>
  </mat-form-field>
  
</div>
